import React, { useEffect, useState } from "react"
import Select from "react-select"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import Dropzone from "react-dropzone"
import {imagePath, sitename} from "constants/constants"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"
// Form Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError, removeError } from "store/actions"
import FieldValidation from "components/Common/FieldValidation"
import { updateBanner } from "store/Content/actions"
import Slidewithcontrol from "pages/Ui/CarouselTypes/slidewithcontrol"
import { getAllBannersCall } from "helpers/repository"
const Edit = props => {
  const dispatch = useDispatch()
  const [banner, set_banner] = useState([])
  const [page_name, set_page_name] = useState({
    label: "",
    value: "",
  })

  const [isMulti, setIsMulti] = useState()

  function handleAcceptedFiles(files) {
    removeError("banner")

    if (files && files != undefined) {
      let newFiles = []
      Array.from(files).forEach(file => {
        // Use this approach if you want to change file object else forEach is redundant
        newFiles.push(file)
      })
      set_banner([...banner, ...newFiles])
    } else {
      console.log("file error")
    }
  }

  useEffect(() => {
    getDefaultState()
    dispatch(apiError(""))
  }, [])

  const urlParams = new URLSearchParams(props.location.search)

  const getDefaultState = () => {
    getAllBannersCall().then(res => {
      let page_name = res.data.data.filter(
        bn => bn["id"] == urlParams.get("id")
      )[0]?.page_name
      set_page_name({
        label: page_name,
        value: page_name,
      })
      let defaultImages = res.data.data.filter(
        df => df["page_name"] == page_name
      )
      defaultImages = defaultImages.map(img => {
        return {
          src: imagePath("banners", img?.banner),
          altText: img?.page_name,
          caption: img?.page_name,
        }
      })
      // set_banner(defaultImages)
    })
  }

  useEffect(() => {
    setIsMulti(false)
    if (page_name?.label == "Home Page") setIsMulti(true)
  }, [page_name])

  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      image: banner,
      page_name: page_name?.label,
    }
    let form_data = new FormData()
    data["image"].forEach(item => form_data.append("image[]", item))
    form_data.append("page_name", data["page_name"])

    dispatch(updateBanner(form_data, props.history, +urlParams.get("id")))
  }

  const formErrors = useSelector(state => state?.CommonState)
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Banners" breadcrumbItem="Edit" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Edit Banner
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Page Name
                  </Label>
                  <Col sm={5}>
                    <Select
                      maxMenuHeight={150}
                      onChange={page => {
                        removeError("page_name")
                        set_page_name(page)
                      }}
                      options={[
                        {
                          value: "All Sports",
                          label: "All Sports",
                        },
                        {
                          value: "Home Page",
                          label: "Home Page",
                        },
                        {
                          value: "Casino Page",
                          label: "Casino Page",
                        },
                      ]}
                      classNamePrefix="select2-selection"
                      value={{
                        label: page_name?.label,
                        value: page_name?.value,
                      }}
                    />
                    {formErrors?.page_name ? (
                      <FieldValidation errorMessage={formErrors?.page_name} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Banner
                  </Label>
                  <Col sm={5}>
                    {banner.length == 0 ? (
                      <Dropzone
                        onDrop={acceptedFiles => {
                          handleAcceptedFiles(acceptedFiles)
                        }}
                        multiple={isMulti}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div
                              className="dz-message needsclick mt-2"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h4>Drop files here or click to upload.</h4>
                              <em style={{ fontSize: "12px", color: "red" }}>
                                (Only *.svg and *.png images will be accepted)
                              </em>
                              <br></br>
                              <em style={{ fontSize: "10px", color: "red" }}>
                                (Banner Dimension should be 770x150)
                              </em>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    ) : (
                      <>
                        <div className="dropzone">
                          <>
                            <div className="promotions-banner-title p-1">
                              <CardTitle>Content Banner</CardTitle>
                              <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => {
                                  removeError("image")
                                  set_banner([])
                                }}
                              ></button>
                            </div>
                            <Card>
                              <CardBody>
                                <Slidewithcontrol
                                  banner={banner}
                                  page_name={page_name}
                                />
                              </CardBody>
                            </Card>
                          </>
                        </div>
                      </>
                    )}

                    {formErrors?.image?.length >= 0 ? (
                      <FieldValidation errorMessage={formErrors?.image[0]} />
                    ) : null}
                  </Col>
                </div>

                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/crm/content")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditBanner = withRouter(Edit)
